import React from 'react'
import { Banner, IconName, Link } from '@node-space/ui-components'

export interface FlagEnabledBannerProps {
  variant: 'info' | 'warning' | 'success' | 'error'
  message: string
  buttonText: string
  buttonLink: string
}

export const FlagEnabledBanner = ({
  variant,
  message,
  buttonText,
  buttonLink,
}: FlagEnabledBannerProps) => {
  const getBannerIcon = (): IconName => {
    switch (variant) {
      case 'warning':
        return 'WarningCircle'
      case 'success':
        return 'CheckCircle'
      case 'error':
        return 'XCircle'
      default:
        return 'Info'
    }
  }

  return (
    <Banner variant={variant} iconName={getBannerIcon()}>
      {message} {buttonText && <Link href={buttonLink}>{buttonText}</Link>}
    </Banner>
  )
}
